<template>
  <div
    :style="{
      height: height+'px',
      // overflow: 'hidden'
    }"
  >
    <div style="height:100%">
      <slot />
    </div>
  </div>
</template>
<script>
  export default {
    props: {
      reservedHeight:{
        type: Number,
        default: null
      },

    },
    computed: {
      height() {
        let height = this.$store.state.window_height;
        if (this.reservedHeight !== null) {
          height = height - this.reservedHeight
        }
        if (this.reservedHeight === null) {
          height = height - 190
        }
        return height
      }
    }
  }
</script>